import React, { useState } from 'react';
import IconButtonComponent from '../../IconButton.component';
import { FavouriteButtonProps } from './FavouriteButton.interface';
import { useAppDispatch } from '../../../hooks/useAppDispatcher.hook';
import {
  addFavouriteThunk,
  deleteFromFavouriteThunk,
} from '../../../redux/Favourites/Favourite.thunk';
import StarIcon from '../../Icons/Star.icon';

export const FavouriteButton = ({
  id,
  isFavourite,
  updateInfo,
  setFavouriteChanged,
}: FavouriteButtonProps) => {
  const dispatch = useAppDispatch();
  const [buttonState, setButtonState] = useState<boolean>(isFavourite);

  const handleOnFavouritesPress = async (
    e: React.MouseEvent<HTMLDivElement>,
  ) => {
    e.stopPropagation();
    e.preventDefault();
    if (!buttonState) {
      await dispatch(addFavouriteThunk({ personId: id }));
      setButtonState(true);
    } else {
      await dispatch(deleteFromFavouriteThunk({ personId: id }));
      setButtonState(false);
    }
    setFavouriteChanged && setFavouriteChanged(true);
    updateInfo && updateInfo();
  };

  return (
    <IconButtonComponent onClick={handleOnFavouritesPress}>
      <StarIcon size={24} color={buttonState ? '#FFD500' : 'gray'} />
    </IconButtonComponent>
  );
};
